import { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Chip,
  IconButton,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useParams, withRouter } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Edit from "@mui/icons-material/Edit";
import NotesOutlined from "@mui/icons-material/NotesOutlined";
import People from "@mui/icons-material/People";
import ContactPage from "@mui/icons-material/ContactPage";
import Description from "@mui/icons-material/Description";
import Language from "@mui/icons-material/Language";
import LocationOn from "@mui/icons-material/LocationOn";
import Phone from "@mui/icons-material/Phone";
import LinkedIn from "@mui/icons-material/LinkedIn";
import Groups from "@mui/icons-material/Groups";
import { GiOnTarget } from "react-icons/gi";
import moment from "moment";
import "moment/locale/fr";
import DescriptionSociete from "./Tabs/Description";
import Mission from "./Tabs/Missions";
import Contact from "./Tabs/CONTACT";
import { NoteSociete } from "./Tabs/index";
import CandidatsSociete from "./Tabs/CandidatsSociete";
import Loader from "../../../components/Loader/Loader";
import LabelHtmlToTextCustom from "../../../components/LabelHtmlToTextCustom/LabelHtmlToTextCustom";
import { getDetails } from "../../../services/SocieteService";
import { theme } from "../../../utils/Theme";
import "./visualiserSociete.css";

const VisualiserSociete = ({ history }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabParam = Number(queryParams.get("tab"));

  const [value, setValue] = useState(Number.isNaN(tabParam) ? 0 : tabParam);
  const [societe, setSociete] = useState({});
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const isSmall = useMediaQuery(theme.breakpoints.between(0, 480));
  const isMedium = useMediaQuery(theme.breakpoints.between(481, 992));

  useEffect(() => {
    let isActive = true;

    const fetchData = async () => {
      setLoading(true);
      try {
        const societeData = await getDetails(id);
        if (isActive) setSociete(societeData.data);
      } catch (error) {
        if (isActive) history.push({ pathname: "/accueil" });
      } finally {
        if (isActive) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isActive = false;
    };
  }, [id, history]);

  useEffect(() => {
    if (history.location.state && history.location.state.snack) {
      const state = { ...history.location.state };
      delete state.snack;
      history.replace({ ...history.location, state });
    }
  }, [history]);

  const handleTabs = (_event, newValue) => setValue(newValue);

  const editSociete = () => {
    history.push({ pathname: `/societe/${id}/update` });
  };

  const formatValue = (value) => ([null, "", "null", undefined].includes(value) ? "-" : value);
  const cleanUrl = (value) => {
    if (!value || value === "-") return "";
    return String(value).startsWith("http") ? value : `https://${value}`;
  };
  const initials = (societe.nom_societe || "SO").split(" ").slice(0, 2).map((word) => word[0]).join("").toUpperCase();
  const updatedAt = societe.updatedAt?.date || societe.updatedAt;

  const infoSections = [
    {
      title: "Informations",
      rows: [
        { label: "Statut", value: formatValue(societe.statut) },
        { label: "Telephone", value: formatValue(societe.n_tel), icon: <Phone fontSize="small" /> },
        { label: "Adresse", value: formatValue(societe.adresse) },
        { label: "Code postal", value: formatValue(societe.code_postal) },
        { label: "LinkedIn", value: formatValue(societe.linkedin), href: cleanUrl(societe.linkedin), icon: <LinkedIn fontSize="small" /> },
      ],
    },
    {
      title: "Profil societe",
      rows: [
        { label: "Localisation", value: formatValue(societe.localisation), icon: <LocationOn fontSize="small" /> },
        { label: "Site internet", value: formatValue(societe.site_internet), href: cleanUrl(societe.site_internet), icon: <Language fontSize="small" /> },
        { label: "Type de societe", value: formatValue(societe.type_societe?.type) },
        { label: "Effectif", value: formatValue(societe.effectif?.type), icon: <Groups fontSize="small" /> },
        { label: "Secteur d'activite", value: formatValue(societe.secteur_dactivite?.secteur) },
      ],
    },
    {
      title: "Sachez que",
      rows: [
        { label: "Note", value: formatValue(societe.sachez_que), rich: true },
      ],
    },
  ];

  const statCards = [
    { label: "Statut", value: formatValue(societe.statut) },
    { label: "Type", value: formatValue(societe.type_societe?.type) },
    { label: "Effectif", value: formatValue(societe.effectif?.type) },
    { label: "Secteur", value: formatValue(societe.secteur_dactivite?.secteur) },
  ];

  const tabs = [
    { label: "NOTES", icon: <NotesOutlined />, component: <NoteSociete /> },
    { label: "MISSIONS", icon: <GiOnTarget />, component: <Mission nomSociete={societe.nom_societe} /> },
    { label: "CONTACTS", icon: <ContactPage />, component: <Contact nomSociete={societe.nom_societe} /> },
    { label: "DESCRIPTION", icon: <Description />, component: <DescriptionSociete /> },
    { label: "CANDIDATS", icon: <People />, component: <CandidatsSociete /> },
  ];

  return (
    <Box className="societe-view-page">
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="societe-view-actions">
            <div className="societe-view-actionsLeft">
              <IconButton className="societe-view-back" onClick={() => history.goBack()} title="Retour">
                <ArrowBack />
              </IconButton>
              <Button variant="outlined" disabled>Precedent</Button>
              <Button variant="contained" color="error">Supprimer</Button>
              <Button variant="outlined">Suivant</Button>
            </div>
            <Button className="societe-view-edit" variant="contained" startIcon={<Edit />} onClick={editSociete}>
              Modifier
            </Button>
          </div>

          <header className="societe-view-hero">
            <div className="societe-view-identity">
              <Avatar className="societe-view-avatar">{initials}</Avatar>
              <div>
                <div className="societe-view-titleLine">
                  <Typography className="societe-view-title">{formatValue(societe.nom_societe)}</Typography>
                  {societe.numSociete && <Chip className="societe-view-num" label={`N ${societe.numSociete}`} />}
                </div>
                <Typography className="societe-view-subtitle">
                  {societe.accountManager?.accountManager ? `Suivi par ${societe.accountManager.accountManager}` : "Societe cliente"}
                  {updatedAt ? ` - mise a jour : ${moment(updatedAt).locale("fr").format("DD MMMM YYYY - HH:mm")}` : ""}
                </Typography>
              </div>
            </div>
            <div className="societe-view-quickStats">
              {statCards.map((item) => (
                <div className="societe-view-stat" key={item.label}>
                  <span>{item.label}</span>
                  <strong>{item.value}</strong>
                </div>
              ))}
            </div>
          </header>

          <main className="societe-view-layout">
            <aside className="societe-view-sidebar">
              {infoSections.map((section) => (
                <section className="societe-view-infoCard" key={section.title}>
                  <div className="societe-view-infoTitle">
                    <span />
                    {section.title}
                  </div>
                  <div className="societe-view-infoRows">
                    {section.rows.map((row) => (
                      <div className="societe-view-infoRow" key={row.label}>
                        <span className="societe-view-infoLabel">{row.icon}{row.label}</span>
                        <span className="societe-view-infoValue">
                          {row.href ? (
                            <a href={row.href} target="_blank" rel="noreferrer">{row.value}</a>
                          ) : row.rich ? (
                            <LabelHtmlToTextCustom data={row.value} />
                          ) : (
                            row.value
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                </section>
              ))}
            </aside>

            <section className="societe-view-workspace">
              <Box className="societe-view-tabsBar">
                <Tabs
                  value={value}
                  onChange={handleTabs}
                  variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile
                  sx={{
                    '& .MuiTabs-indicator': { backgroundColor: '#fff', height: 3, borderRadius: '3px 3px 0 0' },
                    '& .MuiTabs-scrollButtons': { color: '#fff', width: 32, '&.Mui-disabled': { opacity: 0.3 } },
                  }}
                >
                  {tabs.map((tab) => (
                    <Tab
                      key={tab.label}
                      label={(
                        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          {tab.icon}
                          {!(isSmall || isMedium) && <span>{tab.label}</span>}
                        </Box>
                      )}
                    />
                  ))}
                </Tabs>
              </Box>
              <div className="societe-view-tabPanel">
                {tabs.map((tab, index) => (
                  <TabPanel key={tab.label} value={value} index={index}>
                    {tab.component}
                  </TabPanel>
                ))}
              </div>
            </section>
          </main>
        </>
      )}
    </Box>
  );
};

export default withRouter(VisualiserSociete);

function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}
